import omit from 'lodash/omit';
import pick from 'lodash/pick';
import React from 'react';
import BsForm from 'react-bootstrap/Form';
import { FormControlProps } from 'react-bootstrap/FormControl';
import { BsPrefixProps, ReplaceProps } from 'react-bootstrap/helpers';
import { DecoratedFormUnitProps } from './DecoratedFormUnit';

type FormControlElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

export { BsForm };

const FORM_UNIT_PROPS = [
  'groupClassName',
  'groupStyle',
  'label',
  'error',
  'hint',
  'markRequired',
  'icon',
];

export type BsFormProps<As extends React.ElementType = 'input'> = ReplaceProps<
  As,
  BsPrefixProps<As> &
    Omit<FormControlProps, 'onChange'> & {
      onChange?: React.ChangeEventHandler<FormControlElement>;
    }
>;

export type InputProps<El extends React.ElementType = 'input'> = Omit<
  DecoratedFormUnitProps,
  'children'
> &
  BsFormProps<El>;

export function getFormUnitProps<T>(props: any): {
  unitProps: DecoratedFormUnitProps;
  rest: T;
} {
  return {
    unitProps: pick(props, FORM_UNIT_PROPS) as DecoratedFormUnitProps,
    rest: omit(props, FORM_UNIT_PROPS) as T,
  };
}

export function parseInputProps<As extends React.ElementType = 'input'>(
  props: InputProps<As>,
): {
  unitProps: DecoratedFormUnitProps;
  inputProps: BsFormProps<As>;
} {
  return {
    unitProps: pick(props, FORM_UNIT_PROPS),
    inputProps: omit(props, FORM_UNIT_PROPS),
  } as any;
}
